import { inject, lifecycleHooks } from 'aurelia';
import { getLogger } from './common/logging';
import { UserSession } from './services/user-session';

let log = getLogger('authorize-hook');

@lifecycleHooks()
@inject(UserSession)
export class AuthorizeHook {
  constructor(session) {
    this.session = session;
  }

  canLoad(viewModel, params, next) {
    const customer = next.params.customer;

    if (next.data.public) return true;
    if (next.component.name === 'not-found') return true;

    let active = this.session.isActive();
    log.info(`authorize-hook. active=${active}`, customer);
    if (active) {
      active = this.session.user.customer.toUpperCase() === customer.toUpperCase();
    }

    if (active && this.session.user.hasOwnProperty('isRegistrationToken') && this.session.user.isRegistrationToken === true) {
      if (next.data.name === 'regbankid') return true;
      return `/${customer}/account/regbankid`;
    }

    if (!active) {
      log.info(`authorize-hook. logout`);
      this.session.end();
      return `/${customer}/login`;
    }

    return true;
  }
}
